/**
 * @generated SignedSource<<37ab18208f2f457d40c380eaeaf679b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_item$data = {
  readonly isPublishedPrivate: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_item";
};
export type PdpRespIconBubblesWrapper_item$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublishedPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "833af15a04c0ea4eab1bb0e893ade96f";

export default node;
